import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class VendorTransTypeForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet()); 
  }

  private viewGet(): CerFormView {
    
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'vendor-trans-type', dataApiName: 'VendorTransType', primaryType: 'vendorTransType',
      text: 'Kreditor posttyper', textSingular: 'Kreditor posttype',
      primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history'],
      allowCreate: false, allowEdit: false, allowDelete: false, 
    };
    
    view.fieldMetadata = [
      { name: 'name', text: 'Tekst' },
    ];
    
    return view;
  }
}
